/**
 * Mission topbar crumb — brand · org · / · project.
 *
 * shadcn Button is `shrink-0`. Pairing that with two small max-widths
 * (`max-w-[9.5rem]` + `max-w-[11rem]`) made org and project ellipsize at once.
 *
 * Rule: org keeps natural width so short names (PCBX) never truncate.
 * Project is the only segment that yields (`min-w-0 shrink` overrides Button).
 * `title` on each trigger still exposes the full name.
 */

export const MISSION_CRUMB_WRAP_CLASS =
  "flex min-w-0 items-center gap-1 text-[13px] text-muted-foreground";

export const MISSION_CRUMB_ORG_BTN_CLASS =
  "h-8 max-w-[min(100%,16rem)] shrink-0 gap-1 px-1.5 text-[13px] font-medium normal-case tracking-normal text-foreground";

/** Outer flex item — this is what yields, because Button is shrink-0. */
export const MISSION_CRUMB_PROJECT_WRAP_CLASS = "flex min-w-0 max-w-[min(100%,32rem)] shrink items-center";

export const MISSION_CRUMB_PROJECT_BTN_CLASS =
  "h-8 w-full max-w-full min-w-0 justify-start gap-1 px-1.5 text-[13px] font-medium normal-case tracking-normal text-foreground";

export const MISSION_CRUMB_ORG_LABEL_CLASS = "max-w-full truncate";

export const MISSION_CRUMB_PROJECT_LABEL_CLASS = "min-w-0 truncate";

/** Forbidden dual-cap pair that produced two CSS ellipses in the crumb. */
export const FORBIDDEN_CRUMB_MAX_WIDTHS = ["max-w-[9.5rem]", "max-w-[11rem]"] as const;

export function crumbHasDualEllipsisCaps(source: string): boolean {
  return FORBIDDEN_CRUMB_MAX_WIDTHS.every((token) => source.includes(token));
}
